import { AuthPageContent } from '@/modules/Auth';

export const SignIn = (): JSX.Element => <AuthPageContent />;

export default SignIn;
